/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Progress/Content/Action/SubmitAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 alignSelf="flex-end"
 paddingBottom={dtSpaceXs}
 paddingTop={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 onClick={() => setFlowTo("/App/Widget/Content/Questions/Review")}
 isSelected={flow.has("/App/Widget/Content/Questions/Review")}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Complete"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}